<template>
  <v-row justify="center">
    <v-dialog :value="profileDialog" persistent max-width="600px">
      <div style="position:relative">
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="saveProfile"
          v-if="user"
          lazy-validation
        >
          <v-card :loading="saving">
            <v-card-title>
              <v-icon large left>mdi-face-profile</v-icon>
              <span class="text-h4">Profile</span>
            </v-card-title>
            <v-card-text>
              <v-alert dense type="warning" v-if="errors.server">{{errors.server}}</v-alert>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="First name*"
                      v-model="user.first_name"
                      :rules="nameRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Last name*"
                      persistent-hint
                      v-model="user.last_name"
                      :rules="nameRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Email*"
                      v-model="user.email"
                      :rules="emailRules"
                      :error-messages="errors.email"
                      @input="errors.email = ''"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Cell" v-model="user.cell"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox class="mt-0" v-model="changePassword" label="Change password"></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6" v-if="changePassword">
                    <v-text-field label="Password" type="password" v-model="user.password"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" v-if="changePassword">
                    <v-text-field
                      label="Confirm Password"
                      type="password"
                      v-model="user.password_confirmation"
                      :rules="passwordConfirmationRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color outlined @click="profileDialogSet(false)">Close</v-btn>
              <v-btn color="primary" outlined type="submit">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    saving: false,
    changePassword: false,
    valid: false,
    errors: {
      email: ""
    },
    nameRules: [
      v => !!v || "First and last name is required",
      v => (v && v.length >= 3) || "Cannot be less than 3 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    ...mapState("app", ["profileDialog"]),
    passwordConfirmationRules() {
      return [
        v => !!v || "Password confirmation is required",
        () =>
          this.user.password === this.user.password_confirmation ||
          "Password confirmation does not match password"
      ];
    }
  },
  methods: {
    ...mapActions("app", ["profileDialogSet", "showMessage"]),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors.server = "";
    },
    async saveProfile() {
      if (!this.validate()) return;

      try {
        this.saving = true;
        await this.user.save();
        this.saving = false;
        this.changePassword = false;
        this.showMessage({ text: "Profile saved!", color: "green" });
      } catch (error) {
        this.saving = false;
        this.errors.server = error.message;
      }
    }
  },
  watch: {
    user: {
      handler() {
        if (!this.valid) {
          this.resetValidation();
        }
      },
      deep: true
    }
  }
};
</script>